import React from "react";
// import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App";
// import "fontsource-roboto"
import { CssBaseline } from "@mui/material";
import { AppContextProvider } from "./contexts/app-context/AppContext";
import settings from "./app-settings.json";
import { UserContextProvider } from "./contexts/user-context/UserContext";

import { /*QueryClient,*/ QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from 'react-query/devtools';
import { queryClient } from "./services/query-client-service/QueryClientService";
import msalAuthService from "./services/authentication/msal-auth-service/MsalAuthService";
import storageService from "./services/storage/storage-service/StorageService";
import { createRoot } from "react-dom/client";
import Highcharts from "highcharts";

// import "./assets/scadalynx-web.eot";
// import "./assets/scadalynx-web.svg";
// import "./assets/scadalynx-web.ttf";
// import "./assets/scadalynx-web.woff";


// configure the auth service as soon as possible
msalAuthService.setConfig({
  aadClientID: settings.aadClientID,
  aadScopes: [settings.aadScopes]
});
msalAuthService.initialize();

Highcharts.setOptions({
  lang: {
    numericSymbols: undefined,
    thousandsSep: ','
  },
  time: {
    useUTC: true
  }
});

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       //refetchOnWindowFocus: false,
//       staleTime: 60000
//     }
//   }
// });

// V17 ---------------------------------------------------------------
// ReactDOM.render(
//   <React.StrictMode>
//     <QueryClientProvider client={queryClient}>
//       <CssBaseline />
//       <AppContextProvider storageProvider={storageService.local}>
//         <UserContextProvider>
//           <App />
//         </UserContextProvider>
//       </AppContextProvider>
//       <ReactQueryDevtools initialIsOpen={false} toggleButtonProps={{style: { marginLeft: "64px"}}}/>
//     </QueryClientProvider>
//   </React.StrictMode>,
//   document.getElementById("root")
// );
// -------------------------------------------------------------------

// V18 ---------------------------------------------------------------
const container = document.getElementById("root");

const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <CssBaseline />
      <AppContextProvider storageProvider={storageService.local}>
        <UserContextProvider>
          <App />
        </UserContextProvider>
      </AppContextProvider>
      <ReactQueryDevtools initialIsOpen={false} toggleButtonProps={{style: { marginLeft: "64px"}}}/>
    </QueryClientProvider>
  </React.StrictMode>
);
// -------------------------------------------------------------------

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
//serviceWorkerRegistration.register();
// NOTE: Removed this and replaced with ServiceWorkerManager in app.tsx